import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import staticQueryData from "../../../../../public/static/d/3209201862.json";
import React from 'react';
import { StaticQuery } from 'gatsby';
import LocaleSelector from '@arcblock/ux/lib/LocaleSelector';
export default function SmartLocaleSelector(props) {
  return /*#__PURE__*/React.createElement(StaticQuery, {
    query: "3209201862",
    render: function render(data) {
      return /*#__PURE__*/React.createElement(LocaleSelector, Object.assign({}, props, {
        pages: data.allSitePage.nodes.map(function (x) {
          return x.path;
        }).reduce(function (acc, url) {
          acc[url] = true;
          return acc;
        }, {})
      }));
    },
    data: staticQueryData
  });
}